import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualScrollComponent } from './virtual-scroll.component';

@NgModule({
    declarations: [
        VirtualScrollComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        VirtualScrollComponent
    ]
})
export class NcVirtualScrollModule { }